import type { ReactNode } from 'react';

type ChartControlsProps = {
  children: ReactNode;
};

export const ChartControls = ({ children }: ChartControlsProps) => {
  return (
    <div className="flex" style={{ gridArea: 'controls' }}>
      {children}
    </div>
  );
};
